import { render, staticRenderFns } from "./TopicLanguage.vue?vue&type=template&id=2f699a2e&scoped=true&"
import script from "./TopicLanguage.vue?vue&type=script&lang=js&"
export * from "./TopicLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f699a2e",
  null
  
)

export default component.exports